import PropTypes from 'prop-types';

export const AccountProps = PropTypes.shape({
  accountId: PropTypes.string,
  email: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string
});

export const AccountDefaults = {
  accountId: '',
  email: '',
  firstName: '',
  lastName: ''
};
